<template>
    <div class="business-content-main" v-loading="saveLoading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <div class="search-name">合作项目</div>
                    <el-select  class="search-item" size="small" v-model="searchData.Projects" @visible-change="coProjectsVisibleChange($event)">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in projectsList" :key="item.ProjectId" :label="item.ProjectName" :value="item.ProjectId"></el-option>
                    </el-select>
                    <div class="search-name">仓库</div>
                    <el-select
                        v-model="searchData.SId"
                        :loading="loading"
                        class="search-item"
                        size="small"
                        filterable
                        clearable
                        remote
                        @visible-change="warehouseVisibleChange($event)"
                    >
                        <el-option v-for="optionItem in WarehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index"
                            ><span style="float: left">{{ optionItem.WarehouseName }}</span>
                            <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span></el-option
                        >
                    </el-select>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    <el-button size="small" class="search-btn btn-primary" @click="showSearchDialog">更多条件（F2）</el-button>
                    <el-button size="small" icon="fa fa-file-excel-o" class="search-btn btn-primary" @click="exportExcel()">导出Excel</el-button>
                </div>
            </div>
            <div>
                <el-card class="box-card">
                    <div class="data-count">
                        <div class="data-item">
                            <p>现有库存总数</p>
                            <p>{{ statData.countTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>标签成本总额</p>
                            <p style="color: red; font-size: 16px">￥{{ statData.costTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>待入总数</p>
                            <p>
                                {{ statData.waitInTotal }}
                            </p>
                        </div>
                        <div class="data-item">
                            <p>待出总数</p>
                            <p>{{ statData.waitOutTotal }}</p>
                        </div>
                        <div class="data-item border-right-none">
                            <p>留余总数</p>
                            <p style="color: green; font-size: 16px">
                                {{ statData.surplusTotal }}
                            </p>
                        </div>
                    </div>
                </el-card>
            </div>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border
                    style="width: 100%"
                    :default-sort="{ prop: 'SaleTotalAmount', order: 'descending' }"
                    @sort-change="sortChange"
                >
                    <el-table-column show-overflow-tooltip width="60px" type="index" :index="indexMethod" label="排名"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="ProjectName" label="合作项目"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="APCode" label="汽配编码"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="GoodName" label="汽配名称"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="AutoSerise" label="适用车型"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100" prop="Brand" label="品牌"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100" prop="APCate" label="分类"></el-table-column>
                    <el-table-column show-overflow-tooltip width="110" sortable="custom" prop="InventoryAmount" label="现有库存"></el-table-column>
                    <el-table-column show-overflow-tooltip width="110" sortable="custom" prop="CostPrice" label="成本价"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable="custom" width="110" prop="TotalCost" label="总成本"></el-table-column>
                    <el-table-column show-overflow-tooltip width="110" label="标签总成本">
                        <template slot-scope="scope">
                            <div @click="showStatLableDialog(scope.row)" style="color:#5f9eff;">
                                {{ scope.row.LabelTotalCost }}
                            </div>
                        </template>
                    </el-table-column>                    <el-table-column show-overflow-tooltip width="80" prop="TotalStayOut" label="待出仓"></el-table-column>
                    <el-table-column show-overflow-tooltip width="80" prop="TotalStayIn" label="待入仓"></el-table-column>
                    <el-table-column show-overflow-tooltip width="80" prop="TotalSurplus" label="留余"></el-table-column>
                    <el-table-column  label="其他统计" width="85px">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <img class="image-cus" src="@/assets/images/customer.png" title="客户销售数据" @click="showSaleStat(scope.row)" />
                                <img class="image-sup" src="@/assets/images/supplier.png" title="供应商采购数据" @click="showPurchaseStat(scope.row)" />
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
            <el-dialog :close-on-click-modal="false" :title="SaleDialogTitle" :visible.sync="showSaleStatDialog" :append-to-body="true" width="1100px">
                <div v-if="showSaleStatDialog">
                    <saleStat @closeDialog="closeSaleStatDialog" :APId="this.APId" :ShowCus="true"></saleStat>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" :title="PurchaseDialogTitle" :visible.sync="showPurchaseStatDialog" :append-to-body="true" width="1100px">
                <div v-if="showPurchaseStatDialog">
                    <purchaseStat @closeDialog="closePurchaseStatDialog" :APId="this.APId"></purchaseStat>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="标签数据" :visible.sync="showStatLabelDialog"  v-dialog-drag lock-scroll :modal="false" :append-to-body="true" id="ap-dialog" width="1300px">
                <div v-if="showStatLabelDialog" id="statlabel">
                    <statGoodsLabels @closeDialog="closeStatLableDialog" :GoodsId="this.gId" :WarhouseId="this.searchData.SId"></statGoodsLabels>
                </div>
            </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="标签统计搜索"
            :visible.sync="dialogVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-page-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogVisible">
                <el-form ref="form" label-position="left" label-width="75px">
                    <el-form-item label="汽配编码">
                        <el-input class="search-item" size="small" v-model="searchData.APCode" placeholder="汽配编码"></el-input>
                    </el-form-item>
                    <el-form-item label="汽配名称">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.GoodName"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="请输入配件名称"
                            :remote-method="searchGoodName"
                            v-select-scroll-more="searchGoodNameLoad"
                            popper-class="my-select"
                        >
                            <el-option v-for="item in goodNameOptions" :key="item" :label="item" :value="item"> </el-option>
                            <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="适用车型">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.AutoSerise"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="请输入车型"
                            :remote-method="searchAutoSerise"
                            v-select-scroll-more="searchAutoSeriseLoad"
                            popper-class="my-select"
                        >
                            <el-option v-for="item in autoSeriseOptions" :key="item" :label="item" :value="item" style="width: 300px"> </el-option>
                            <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配品牌">
                        <el-select
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="brandVisibleChange($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配分类">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.APCate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            @visible-change="cateVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="合作项目">
                        <el-select style="width: 100%" size="small" v-model="searchData.Projects" @visible-change="coProjectsVisibleChange($event)">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in projectsList" :key="item.ProjectId" :label="item.ProjectName" :value="item.ProjectId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="库存数"><div class="flex">
                    <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol" clearable placeholder="> < =">
                        <el-option key=">=" label=">=" value=">="></el-option>
                        <el-option key=">" label=">" value=">"></el-option>
                        <el-option key="<=" label="<=" value="<="></el-option>
                        <el-option key="<" label="<" value="<"></el-option>
                        <el-option key="=" label="=" value="="></el-option>
                        <el-option key="!=" label="!=" value="!="></el-option>
                        <el-option key="between" label="区间" value="between"></el-option>
                    </el-select>
                    <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Invent1"></el-input>
                    <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Invent2" v-if="searchData.Symbol == 'between'"></el-input>
                    </div>
                    </el-form-item>
                    <el-form-item label="统计时间">
                        <el-date-picker class="search-item" style="width: 100%" v-model="searchData.StartDate" size="small" type="date" placeholder="选择日期"></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
        <el-progress type="circle" :percentage="percentage" class="saveProgress" :class="{ hide: !saveLoading }"></el-progress>
        <div style="z-index: 2001" class="exportmsg" v-if="showExportMsg">
            <span>数据已经准备好，正在生成Excel表格，可能耗时1-5min，请耐心等候……</span>
            <span>您也可以打开新的窗口进行其他的操作</span>
        </div> 
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import saleStat from '@/components/business/revenue/apSaleStat';
import purchaseStat from '@/components/business/revenue/apPurchaseStat';
import statGoodsLabels from '@/components/business/goodsLables/statGoodsLabels';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'inventoryStat',
    components: {
        breadcrumb,
        saleStat,
        purchaseStat,
        statGoodsLabels
    },
    data() {
        return {
            dateTimes: [],
            showPurchaseStatDialog: false,
            showSaleStatDialog: false,
            showStatLabelDialog: false,
            timeVisible: false,
            loading: false,
            loadTotalCost: true,
            brand: [],
            typeList: [],
            SaleDialogTitle: '',
            PurchaseDialogTitle: '',
            projectsList:[],
            projects:'',
            gId:'',
            searchData: {
                Symbol: '',
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                APCate: [],
                SortProp: '',
                SortType: '',
                StartDate: '',
                EndDate: '',
                SId: '',
                Invent1: 0,
                Invent2: 0,
                page: 1,
                limit: 15
            },
            statData: {
                countTotal: 0,
                costTotal: 0,
                waitInTotal: 0,
                waitOutTotal: 0,
                surplusTotal: 0
            },
            labelTotalCost: 0,
            dialogVisible: false,
            goodsCategories: [],
            tableData: [],
            tableDataLength: 0,
            WarehouseList: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            optionLoading: false,
            goodNameOptions: [],
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseOptions: [],
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            percentage: 0, //进度
            currtPage: 1, //页面，表示保存到第几页,
            saveCount: 0, //已保存数
            showExportMsg: false,
            saveLoading:false,
            exportTotalCount: 0, 
        };
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogVisible) this.dialogVisible = false;
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);

        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1 - 1, 0);
        this.dateTimes.push(date1);

        this.searchData.StartDate = date1;
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            let that = this;
            if (key === 113) {
                e.preventDefault();
                that.dialogVisible = true;
            }
            if (key === 27) {
                e.preventDefault();
                if (that.dialogVisible) that.dialogVisible = false;
            }
            if (key === 13) {
                e.preventDefault();
                that.handleSearch();
                return;
            }
            //左键
            if (key == 37) {
                e.preventDefault();
                if (this.searchData.page > 1) {
                    this.searchData.page -= 1;
                    this.getTableData();
                }
                return;
            }
            //右键
            if (key == 39) {
                e.preventDefault();
                if (this.searchData.page < Math.ceil(this.tableDataLength / this.searchData.Limit)) {
                    this.searchData.page += 1;
                    this.getTableData();
                }
                return;
            }
        },
        searchGoodsBrand() {
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                })
                .catch(() => {});
        },
        searchGoodsType() {
            this.$util
                .getEntpApCategoryList()
                .then(data => {
                    if (!data) return;
                    this.typeList = data;
                })
                .catch(() => {});
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                Symbol: '',
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                APCate: [],
                SortProp: '',
                SortType: '',
                StartDate: '',
                EndDate: '',
                projects:'',
                SId: '',
                Invent1: 0,
                Invent2: 0,
                page: 1,
                limit: this.commonPageSize
            };
            this.dateTimes = [];
        },
        getStatData() {
            if (this.searchData.page == 1) {
                this.$util
                    .axiosPost({
                        url: '/api/DataStatistics/LabelCostStatProject_header',
                        data: this.searchData,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        this.statData = {
                            countTotal: data.CountTotal,
                            costTotal: data.CostTotal,
                            waitInTotal: data.WaitInTotal,
                            waitOutTotal: data.WaitOutTotal,
                            surplusTotal: data.SurplusTotal
                        };
                    })
                    .catch(() => {});
            }
        },
        // 获取数据
        getTableData() {
            if (this.searchData.Symbol) {
                if (this.searchData.Symbol == 'between') {
                    if (isNaN(this.searchData.Invent1)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                    if (isNaN(this.searchData.Invent2)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                } else {
                    if (isNaN(this.searchData.Invent1)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                }
            }
            this.$util
                .axiosPost({
                    url: '/api/DataStatistics/LabelCostStatistics_ProjectVs',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        this.noData = true;
                        return;
                    }
                    this.noData = false;
                    this.tableData = data.DataList;
                    this.tableDataLength = res.count;
                    this.getStatData();
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.Limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.searchGoodsType();
            }
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        indexMethod(index) {
            return index + 1 + (this.searchData.page - 1) * this.searchData.limit;
        },
        showSaleStat(row) {
            if (row) {
                this.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.APId = row.Id;
                this.showSaleStatDialog = true;
            }
        },
        closeSaleStatDialog() {
            this.showSaleStatDialog = false;
        },
        showPurchaseStat(row) {
            if (row) {
                this.PurchaseDialogTitle = '采购数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.APId = row.Id;
                this.showPurchaseStatDialog = true;
            }
        },
        coProjectsVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.projectsList.length == 0) that.getCoProjects();
            }
        },
        getCoProjects() {
            this.$util.getAuthCoProjects().then(data => {
                this.projectsList = data;
            });
        },
        closePurchaseStatDialog() {
            this.showPurchaseStatDialog = false;
        },
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.WarehouseList = data;
            });
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.WarehouseList.length <= 1) that.getWarehouse();
            }
        },
        async searchGoodName(key) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            if (this.goodNameForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                this.goodNameOptions = [...this.goodNameOptions, ...data];
            }
        },
        searchGoodNameLoad() {
            this.goodNameForm.Page += 1;
            this.searchGoodName();
        },
        async searchAutoSerise(key) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            if (this.autoSeriseForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...data];
            }
        },
        searchAutoSeriseLoad() {
            this.autoSeriseForm.Page += 1;
            this.searchAutoSerise();
        },
        closeSearchDialog() {
            this.dialogVisible = false;
        },
        showSearchDialog() {
            this.dialogVisible = true;
        },
        exportExcel() {
            let that = this;
            that.$confirm('将筛选结果全部导出！如果数据过多可能耗时稍长', '提醒', {
                type: 'error',
                distinguishCancelAndClose: true
            })
                .then(() => {
                    that.exportData();
                })
                .catch(() => {
                    return;
                });
        },
        exportData() {
            let that = this;
            if (that.tableData.length == 0) {
                that.$util.warningMsg('请筛选记录');
                return;
            }
            that.saveLoading = true;
            //每次取100条数据
            let saveLimit = 1000;
            let reqData = { ...that.searchData };
            reqData.Limit = saveLimit;
            reqData.Page = that.currtPage;

            that.$util
                .axiosPost({
                    url: '/api/DataStatistics/GetLabelCostStat_ProjectToExport',
                    data: reqData,
                    hideLoading: true
                })
                .then(resp => {
                    that.saveCount += saveLimit;
                    let num = parseFloat(that.saveCount);
                    let total = parseFloat(that.tableDataLength);
                    that.percentage = total <= 0 ? 0 : Math.round(Math.round((num / total) * 10000) / 100.0);
                    that.percentage = that.percentage > 100 ? 100 : that.percentage;
                    if (that.tableDataLength <= that.saveCount) {
                        that.showExportMsg = true;
                        that.$util
                            .exportFile({
                                url: '/api/DataStatistics/ExportLabelCostStat_Project'
                            })
                            .then(res => {
                                that.percentage = 0;
                                that.saveCount = 0;
                                that.currtPage = 1;
                                that.saveLoading = false;
                                that.showExportMsg = false;
                                that.$util.successMsg('导出成功');
                            });
                    } else {
                        that.currtPage++;
                        that.exportData();
                    }
                })
                .catch(() => {
                    that.percentage = 0;
                    that.saveCount = 0;
                    that.currtPage = 1;
                    that.saveLoading = false;
                    that.showExportMsg = false;
                });
        },
        showStatLableDialog(row) {
            this.gId = row.Id
            if(!this.showStatLabelDialog)
                this.showStatLabelDialog = true;
            else
                this.$refs.statGoodsLabels.updateTableData(this.gId,this.searchData.SId);
        },
        closeStatLableDialog() {
            this.showStatLabelDialog = false;
        },
    }
};
</script>
<style lang="less" scoped>
#ap-dialog {
    position: absolute;
    top: 0;
    left: 20%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
}
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 20%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }

        .el-button {
            padding: 0;
        }
    }
}
.ops-ctn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .image-sup {
        width: 22px;
        height: 22px;
        margin-right: 10px;
    }
    .image-cus {
        width: 22px;
        height: 22px;
    }
}
.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 9999;
}
.exportmsg {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10000;
    position: absolute;
    top: 48vh;
    left: 55vh;
    font-size: 22px;
    color: rgb(243, 62, 62);
}
</style>
